export const topicNames = {
    "01": "Приветствие и прощание",
    "02": "Вводные слова",
    "03": "Согласие и несогласие",
    "04": "Слова вежливости",
    "05": "Участие в разговоре",
    "06": "Путешествия",
    "07": "Идиомы. Часть I",
    "08": "Идиомы. Часть II",
    "09": "Пословицы",
}